import React, { useState, useRef, useEffect } from "react";
import { useField } from "formik";
import { ChevronDown, ChevronUp } from "lucide-react";

const Dropdown = ({ label, name, options }) => {
  const [field, meta, helpers] = useField(name);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (value) => {
    helpers.setValue(value);
    setIsOpen(false);
  };

  const selectedOption = options.find((o) => o.value === field.value);
  const selectedLabel = selectedOption ? selectedOption.label : "Select usage stage";

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="space-y-[0.5vh] relative" ref={dropdownRef}>
      <p className="text-[1.7vh] font-manropeSB">
        {label} <span className="text-[red]">*</span>
      </p>

      {/* Dropdown Box */}
      <div
        className="flex justify-between items-center bg-[white] text-[2.5vh] text-[#484848] py-2 px-4 rounded-xl border border-gray-300 shadow cursor-pointer"
        onClick={() => setIsOpen((prev) => !prev)}
      >
       <span className="truncate overflow-hidden whitespace-nowrap max-w-[85%]">
  {selectedLabel}
</span>
        {isOpen ? <ChevronUp /> : <ChevronDown />}
      </div>

      {/* Dropdown Options */}
      {isOpen && (
        <div className="absolute top-[100%] left-0 z-20 mt-1 w-full bg-[white] rounded-xl shadow-xl border overflow-hidden">
          {options.map((option, idx) => (
            <div
              key={option.value}
              className={`flex items-center gap-2 px-4 py-3 cursor-pointer hover:bg-gray-100 ${
                idx !== options.length - 1 ? "border-b" : ""
              }`}
              onClick={() => handleSelect(option.value)}
            >
              <div
                className={`min-h-[2.2vh] min-w-[2.2vh] rounded-full border-2 flex items-center justify-center ${
                  field.value === option.value
                    ? "border-smd_golden-light"
                    : "border-gray-400"
                }`}
              >
                {field.value === option.value && (
                  <div className="h-[1.2vh] w-[1.2vh] bg-smd_golden-light rounded-full" />
                )}
              </div>
              <span className="text-[2.3vh] text-[#484848]">{option.label}</span>
            </div>
          ))}
        </div>
      )}

      {/* Error */}
      {meta.touched && meta.error && (
        <div className="text-red-500 text-sm mt-1">{meta.error}</div>
      )}
    </div>
  );
};

export default Dropdown;
